<template>
  <form
    id="client-profile"
    @submit.prevent="saveClient"
    class="form-prepo-et w-form"
  >
    <div
      v-for="(error, key) in errors"
      :key="key"
      class="error-text"
    >
      {{ error.join("\n") }}
    </div>
    <section v-show="activeSection === 'personal'" class="client-data-section">
    <div class="input-group">
      <label class="field-label">Meno<strong></strong></label
      ><input
      v-model="form.firstName"
      name="firstName"
      type="text"
      class="text-input w-input"
      maxlength="256"
    />
    </div>
    <div class="input-group">
      <label class="field-label">Priezvisko<strong></strong></label
      ><input
      v-model="form.lastName"
      name="lastName"
      type="text"
      class="text-input w-input"
      maxlength="256"
    />
    </div>
    <div v-if="wrongEmail" class="red--text d-flex justify-content-center mb-1">Emailová adresa je už zabratá.</div>
    <div class="input-group">
      <label class="field-label">Email<strong></strong></label
      ><input
      v-model="form.email"
      name="email"
      type="email"
      class="text-input w-input"
      maxlength="256"
    />
    </div>
    <div class="input-group">
      <label class="field-label">Telefón<strong></strong></label
      ><input
        v-model="form.telNumber"
        name="telNumber"
        type="tel"
        pattern="\+4219\d{8}"
        oninvalid="this.setCustomValidity('Zadajte číslo vo formáte +4219XXXXXXXX')"
        oninput="this.setCustomValidity('')"
        class="text-input w-input"
      />
    </div>
    <div class="input-group">
      <label class="field-label"
      >Rodné priezvisko<strong></strong></label
      ><input
      v-model="form.birthName"
      name="birthName"
      type="text"
      class="text-input w-input"
      maxlength="256"
    />
    </div>
    <div class="input-group">
      <label class="field-label"
      >Dátum narodenia<strong></strong
      ></label>
      <input
        name="dateOfBirth"
        v-model="form.dateOfBirth"
        type="date"
        :max="todayLong"
        class="text-input w-input date-input"
        maxlength="256"
      />
    </div>
    <div class="input-group">
      <label class="field-label"
      >Rodné číslo</label
      ><input
      v-model="form.birthNumber"
      name="placeOfBirth"
      type="text"
      class="text-input w-input"
      maxlength="256"
    />
    </div>
    <div class="input-group">
      <label class="field-label"
      >Miesto narodenia<strong></strong></label
      ><input
      v-model="form.placeOfBirth"
      name="placeOfBirth"
      type="text"
      class="text-input w-input"
      maxlength="256"
    />
    </div>
    <div class="input-group">
      <label class="field-label"
      >Štátna príslušnosť<strong></strong></label
      ><input
      name="nationality"
      v-model="form.nationality"
      type="text"
      class="text-input w-input"
      maxlength="256"
    />
    </div>
    <div class="input-group">
      <label class="field-label"
      >Číslo dokladu totožnosti<strong></strong></label
      ><input
      v-model="form.identityNumber"
      name="identityNumber"
      type="text"
      class="text-input w-input"
      maxlength="256"
    />
    </div>
    <div class="input-group">
      <label class="field-label">IBAN<strong></strong></label
      ><input
      name="iban"
      v-model="form.iban"
      type="text"
      class="text-input w-input"
      maxlength="256"
      minlength="8"
    />
    </div>
    <div class="input-group">
      <label class="field-label"
      >Expirácia dokladu<strong></strong
      ></label>
      <input
        v-model="form.identityDocumentExpiration"
        type="date"
        :min="todayLong"
        class="text-input w-input date-input"
        maxlength="256"
      />
    </div>
    <div class="input-group">
      <label class="field-label"
      >Dátum vydania dokladu<strong></strong
      ></label>
      <input
        v-model="form.op_vytvoreny"
        type="date"
        :max="todayLong"
        class="text-input w-input date-input"
        maxlength="256"
      />
    </div>
    <div class="section-title">
      <div class="text-small blc-color">Adresa trvalého pobytu</div>
    </div>
    <sidlo-input
      @address-change="setAddress($event, 'permanent')"
      :type="'house'"
      :property-meta="splitAddressObject('permanent')"
      always-shown
      country-dropdown
    />
    <div class="section-title poniter noselect" @click="correspondenceAddressShown = !correspondenceAddressShown">
      <div class="bold bl-color">{{ !correspondenceAddressShown ? "+ pridať" : "- odobrať" }} korešpondenčnú adresu
      </div>
    </div>
    <div v-if="correspondenceAddressShown">
      <sidlo-input
        @address-change="setAddress($event, 'correspondence')"
        :type="'house'"
        :property-meta="splitAddressObject('correspondence')"
        always-shown
        country-dropdown
      />
    </div>
    </section>

    <section v-show="activeSection === 'bonita'" class="client-data-section">
      <div class="section-title section-heading">
        <div>
          <div class="text-small blc-color">Bonita klienta</div>
          <div class="light">Údaje používané pri výpočte limitov a bankových ponúk.</div>
        </div>
      </div>
      <div class="input-group">
        <label for="bonita-age" class="field-label">Vek</label>
        <input
          id="bonita-age"
          v-model.number="form.age"
          :disabled="!!form.dateOfBirth"
          type="number"
          min="1"
          max="120"
          class="text-input w-input"
        />
        <div v-if="form.dateOfBirth" class="field-help">
          Vypočítaný z dátumu narodenia: {{ calculatedAge }} rokov
        </div>
      </div>
      <div class="dropdown-input-custom rest-input">
        <dropdown-select
          @select="setDropdownValue($event, 'maritalStatus')"
          :id="'bonita_rodinny_stav'"
          :init-value="form.maritalStatus"
          :options="formTemplate.rodinny_stav.choices"
          normal
          :name="'Rodinný stav'"
        />
      </div>
      <div class="dropdown-input-custom rest-input">
        <dropdown-select
          @select="setDropdownValue($event, 'education')"
          :id="'bonita_vzdelanie'"
          :init-value="form.education"
          :options="formTemplate.vzdelanie.choices"
          normal
          :name="'Vzdelanie'"
        />
      </div>
      <div class="dropdown-input-custom rest-input">
        <dropdown-select
          @select="setDropdownValue($event, 'currentHousing')"
          :id="'bonita_aktualne_byvate'"
          :init-value="form.currentHousing"
          :options="formTemplate.aktualne_byvate.choices"
          normal
          :name="'V súčasnosti bývam v nehnuteľnosti'"
        />
      </div>
      <div class="dropdown-input-custom rest-input">
        <dropdown-select
          @select="setDropdownValue($event, 'narrowedBsm')"
          :id="'bonita_zuzene_bsm'"
          :init-value="form.narrowedBsm"
          :options="booleanForm"
          normal
          :name="'Zúžené BSM'"
        />
      </div>
      <div class="dropdown-input-custom rest-input">
        <dropdown-select
          @select="setDropdownValue($event, 'specialBankRelation')"
          :id="'bonita_osobitny_vztah'"
          :init-value="form.specialBankRelation"
          :options="booleanForm"
          normal
          :name="'Osobitný vzťah k banke'"
        />
      </div>

      <div v-if="mortgage" class="household-children">
        <div class="section-title section-heading">
          <div>
            <div class="text-small blc-color">Deti domácnosti</div>
            <div class="light">Každé dieťa zadajte iba do jednej skupiny.</div>
          </div>
        </div>
        <div class="input-group">
          <label for="kids-applicant-only" class="field-label">Deti len žiadateľa</label>
          <input
            id="kids-applicant-only"
            v-model.number="form.kidsApplicantOnly"
            type="number"
            min="0"
            max="255"
            step="1"
            class="text-input w-input required"
            required
          />
        </div>
        <template v-if="coApplicant">
          <div class="input-group">
            <label for="kids-shared" class="field-label">Spoločné deti</label>
            <input
              id="kids-shared"
              v-model.number="form.kidsShared"
              type="number"
              min="0"
              max="255"
              step="1"
              class="text-input w-input required"
              required
            />
          </div>
          <div class="input-group">
            <label for="kids-coapplicant-only" class="field-label">Deti len spolužiadateľa</label>
            <input
              id="kids-coapplicant-only"
              v-model.number="form.kidsCoApplicantOnly"
              type="number"
              min="0"
              max="255"
              step="1"
              class="text-input w-input required"
              required
            />
          </div>
        </template>
        <div class="children-total">Celkový počet detí: {{ totalChildren }}</div>
      </div>
    </section>
  </form>
</template>

<script>
import DropdownSelect from "../../../DropdownSelect";
import { patchUserProfileByID } from "@/services/brokerService";
import SidloInput from "@/components/shared/SidloInput.vue";

export default {
  name: "PersonalInfoForm",
  components: {SidloInput, DropdownSelect},
  props: {
    client: Object,
    errors: Object,
    activeSection: {
      type: String,
      default: "personal",
    },
  },
  computed: {
    calculatedAge () {
      return this.calculateAge(this.form.dateOfBirth);
    },
    totalChildren () {
      return Number(this.form.kidsApplicantOnly || 0)
        + Number(this.form.kidsShared || 0)
        + Number(this.form.kidsCoApplicantOnly || 0);
    },
  },
  created () {
    this.formTemplate = this.$store.getters["formStore/getFormByType"]("clientProfileForm");
    this.form.firstName = this.client.clientInfo.firstName;
    this.form.lastName = this.client.clientInfo.lastName;
    if (!this.client.clientInfo.email.includes('@nomail.bankari.sk')) {
      this.form.email = this.client.clientInfo.email;
    }
    this.form.op_vytvoreny = this.client.clientProfile.op_vytvoreny;
    this.form.telNumber = this.client.clientProfile.telephone;
    this.form.maritalStatus = this.client.clientProfile.rodinny_stav;
    this.form.age = this.client.clientProfile.vek_v_case_vyplnania;
    this.form.education = this.client.clientProfile.vzdelanie;
    this.form.currentHousing = this.client.clientProfile.aktualne_byvate;
    this.form.narrowedBsm = this.client.clientProfile.zuzene_bsm;
    this.form.specialBankRelation = this.client.clientProfile.osobitny_vztah_k_banke;
    this.form.birthName = this.client.clientProfile.rodne_priezvisko;
    this.form.dateOfBirth = this.client.clientProfile.datum_narodenia;
    this.form.birthNumber = this.client.clientProfile.rodne_cislo;
    this.form.placeOfBirth = this.client.clientProfile.miesto_narodenia;
    this.form.nationality = this.client.clientProfile.statna_prislusnost;
    this.form.identityNumber = this.client.clientProfile.op_cislo;
    this.form.iban = this.client.clientProfile.IBAN;
    this.form.identityDocumentExpiration = this.client.clientProfile.op_platnost_do;
    this.form.permanent_address_country = this.client.clientProfile.permanent_address_country;
    this.form.permanent_address_county = this.client.clientProfile.permanent_address_county;
    this.form.permanent_address_district = this.client.clientProfile.permanent_address_district;
    this.form.permanent_address_city = this.client.clientProfile.permanent_address_city;
    this.form.permanent_address_street = this.client.clientProfile.permanent_address_street;
    this.form.permanent_address_number = this.client.clientProfile.permanent_address_number;
    this.form.permanent_address_popisne = this.client.clientProfile.permanent_address_popisne;
    this.form.permanent_address_zip = this.client.clientProfile.permanent_address_zip;
    this.form.correspondence_address_country = this.client.clientProfile.correspondence_address_country;
    this.form.correspondence_address_county = this.client.clientProfile.correspondence_address_county;
    this.form.correspondence_address_district = this.client.clientProfile.correspondence_address_district;
    this.form.correspondence_address_city = this.client.clientProfile.correspondence_address_city;
    this.form.correspondence_address_street = this.client.clientProfile.correspondence_address_street;
    this.form.correspondence_address_number = this.client.clientProfile.correspondence_address_number;
    this.form.correspondence_address_popisne = this.client.clientProfile.correspondence_address_popisne;
    this.form.correspondence_address_zip = this.client.clientProfile.correspondence_address_zip;
    if (this.client.clientProfile.correspondence_address_country
      || this.client.clientProfile.correspondence_address_county
      || this.client.clientProfile.correspondence_address_district
      || this.client.clientProfile.correspondence_address_city
      || this.client.clientProfile.correspondence_address_street
      || this.client.clientProfile.correspondence_address_number
    ) {
      this.correspondenceAddressShown = true;
    }
    this.mortgage = this.client.mortgageContext
      ? this.$store.getters["mortgageDetailState/getMortgage"] || null
      : null;
    this.coApplicant = this.mortgage
      ? this.$store.getters["mortgageDetailState/getCoApplicant"] || null
      : null;
    if (this.mortgage) {
      const applicant = this.$store.getters["mortgageDetailState/getApplicant"];
      const shared = this.coApplicant
        ? Number(this.mortgage.pocet_spolocnych_nezaopatrenych_deti || 0)
        : 0;
      const applicantTotal = Number(applicant?.client_profile?.pocet_nezaopatrenych_deti || 0);
      const coApplicantTotal = Number(this.coApplicant?.client_profile?.pocet_nezaopatrenych_deti || 0);
      this.form.kidsShared = shared;
      this.form.kidsApplicantOnly = Math.max(0, applicantTotal - shared);
      this.form.kidsCoApplicantOnly = Math.max(0, coApplicantTotal - shared);
    }
  },
  methods: {
    splitAddressObject(type) {
      const addressObject = {};

      for (const [key, value] of Object.entries(this.client.clientProfile)) {
        if (!key.includes("address") || !key.includes(type)) continue;

        let keySplit = key.split("_");
        keySplit = keySplit.filter((k) => k !== type);

        let keyMapped = keySplit.join("_");
        keyMapped = this.addressKeysPairs[keyMapped];

        addressObject[keyMapped] = value;
      }

      return addressObject;
    },
    setAddress(address, prefix) {
      for (const [key, value] of Object.entries(address)) {
        const addressKey = this.findByValue(this.addressKeysPairs, key);

        if (!addressKey) continue;

        const addressKeyMapped = `${prefix}_${addressKey}`;
        this.form[addressKeyMapped] = value;
      }
    },
    findByValue(object, value) {
      const key = Object.keys(object).find(k => object[k] === value);
      return key ? key : null;
    },
    setDropdownValue (value, dropdownName) {
      this.form[dropdownName] = value;
    },
    calculateAge (dateOfBirth) {
      if (!dateOfBirth) return Number(this.form.age || 0);
      const birthDate = new Date(dateOfBirth);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();
      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age -= 1;
      }
      return Math.max(0, age);
    },
    async saveClient () {
      const clientProfile = {
        email: this.form.email,
        op_vytvoreny: this.form.op_vytvoreny,
        telephone: this.form.telNumber,
        rodinny_stav: this.form.maritalStatus,
        vek_v_case_vyplnania: this.calculateAge(this.form.dateOfBirth),
        vzdelanie: this.form.education,
        aktualne_byvate: this.form.currentHousing,
        zuzene_bsm: this.form.narrowedBsm,
        osobitny_vztah_k_banke: this.form.specialBankRelation,
        rodne_priezvisko: this.form.birthName,
        datum_narodenia: this.form.dateOfBirth === "" ? null : this.form.dateOfBirth,
        rodne_cislo: this.form.birthNumber,
        miesto_narodenia: this.form.placeOfBirth,
        statna_prislusnost: this.form.nationality,
        op_cislo: this.form.identityNumber,
        IBAN: this.form.iban,
        op_platnost_do: this.form.identityDocumentExpiration,
        permanent_address_country: this.form.permanent_address_country,
        permanent_address_county: this.form.permanent_address_county,
        permanent_address_district: this.form.permanent_address_district,
        permanent_address_city: this.form.permanent_address_city,
        permanent_address_street: this.form.permanent_address_street,
        permanent_address_number: this.form.permanent_address_number,
        permanent_address_popisne: this.form.permanent_address_popisne,
        permanent_address_zip: this.form.permanent_address_zip,
        correspondence_address_country: this.form.correspondence_address_country,
        correspondence_address_county: this.form.correspondence_address_county,
        correspondence_address_district: this.form.correspondence_address_district,
        correspondence_address_city: this.form.correspondence_address_city,
        correspondence_address_street: this.form.correspondence_address_street,
        correspondence_address_number: this.form.correspondence_address_number,
        correspondence_address_popisne: this.form.correspondence_address_popisne,
        correspondence_address_zip: this.form.correspondence_address_zip,
      };
      clientProfile.id = this.client.clientProfile.id;
      clientProfile.user = this.client.clientProfile.user;

      const mortgageChildren = this.mortgage ? {
        applicant_only_children: Number(this.form.kidsApplicantOnly || 0),
        shared_children: this.coApplicant ? Number(this.form.kidsShared || 0) : 0,
        coapplicant_only_children: this.coApplicant ? Number(this.form.kidsCoApplicantOnly || 0) : 0,
      } : null;

      try {
        this.wrongEmail = false;
        const response = await patchUserProfileByID(this.client.clientInfo.id, {
          email: this.form.email ? this.form.email : this.client.clientInfo.email,
          first_name: this.form.firstName,
          last_name: this.form.lastName
        });
        this.$emit("client-saved", {
          clientInfo: clientProfile,
          userProfile: response.data,
          mortgageChildren,
        });
      } catch (error) {
        if (error?.response?.status === 400) {
          this.wrongEmail = true;
          return;
        }
        this.$store.commit("appState/setSuccessMessage", {
          text: "Osobné údaje klienta sa nepodarilo uložiť",
          type: "error",
        });
      }
    },
  },
  data: () => ({
    mortgage: null,
    coApplicant: null,
    wrongEmail: false,
    todayLong: new Date().toISOString().substr(0, 10),
    todayShort: new Date().toISOString().substr(0, 7),
    formTemplate: null,
    form: {
      firstName: null,
      lastName: null,
      email: null,
      telNumber: null,
      maritalStatus: null,
      age: null,
      education: null,
      currentHousing: null,
      narrowedBsm: null,
      specialBankRelation: null,
      kidsApplicantOnly: 0,
      kidsShared: 0,
      kidsCoApplicantOnly: 0,
      birthName: null,
      dateOfBirth: null,
      birthNumber: null,
      placeOfBirth: null,
      nationality: null,
      identityNumber: null,
      iban: null,
      identityDocumentExpiration: null,
      permanent_address_country: null,
      permanent_address_county: null,
      permanent_address_district: null,
      permanent_address_city: null,
      permanent_address_street: null,
      permanent_address_number: null,
      permanent_address_popisne: null,
      permanent_address_zip: null,
      correspondence_address_country: null,
      correspondence_address_county: null,
      correspondence_address_district: null,
      correspondence_address_city: null,
      correspondence_address_street: null,
      correspondence_address_number: null,
      correspondence_address_popisne: null,
      correspondence_address_zip: null,
    },
    correspondenceAddressShown: false,
    addressKeysPairs: {
      "address_country": "address_text_country",
      "address_county": "address_text_county",
      "address_district": "address_text_district",
      "address_city": "address_text_city",
      "address_street": "address_text_street",
      "address_number": "address_text_number",
      "address_popisne": "address_text_popisne",
      "address_zip": "address_text_zip",
    },
    correspondenceAddress: {
      country: null,
      city: null,
      street: null,
      addressNumber: null,
      addressPopisne: null,
      psc: null,
    },
    booleanForm: [
      {display_name: "áno", value: true},
      {display_name: "nie", value: false},
    ],
  }),
  // pridané cez GPT dňa 9_9_2025
  watch: {
    "form.telNumber"(val) {
      if (!val) return;

      // odstráni medzery
      let number = val.replace(/\s+/g, "");

      // ak začína na 09..., prevedie na +421...
      if (/^09\d{8}$/.test(number)) {
        number = "+421" + number.substring(1);
      }

      this.form.telNumber = number;
    },
    "form.dateOfBirth"(value) {
      if (value) this.form.age = this.calculateAge(value);
    }
  }
}
</script>

<style scoped>
#client-profile,
.client-data-section {
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}

.client-data-section {
  min-height: 280px;
}

.client-data-section > * {
  box-sizing: border-box;
  min-width: 0;
  max-width: 100%;
}

.client-data-section .text-input,
.client-data-section .dropdown-input-custom {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
}

.section-heading {
  align-items: flex-start;
  margin: 4px 0 14px;
  padding: 10px 4px 14px;
  text-align: left;
}

.field-help {
  margin-top: 6px;
  color: #6f7f96;
  font-size: 12px;
}

.household-children {
  margin-top: 30px;
  padding-top: 12px;
  border-top: 1px solid #dbe7f3;
}

.children-total {
  margin-top: 14px;
  color: #0d2b65;
  font-weight: 700;
}
</style>
